import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FaqComponent } from '../../cms/faq/faq.component';
import { StaffComponent } from '../../cms/staff/staff.component';
import { AuthGuard } from '../../guards/auth-guard';
import { LoginGuard } from '../../guards/login.guard';
import { DefaultLayoutComponent } from '../../layouts/default-layout/default-layout.component';
import { SharedModule } from '../../shared/shared.module';
import { RegisterComponent } from '../../user/account/views/register/register.component';
import { LoginComponent } from '../auth/login/login.component';
import { SignoutComponent } from '../auth/signout/signout.component';
import { ArticleComponent } from '../blog/article/article.component';
import { BlogCategoryComponent } from '../blog/blog-category/blog-category.component';
import { BlogModule } from '../blog/blog.module';
import { CategoriesComponent } from '../blog/categories/categories.component';
import { ChatModule } from '../chat/chat.module';
import { CookieConsentModule } from '../cookie-consent/cookie-consent.module';
import { DefaultSiteSectionsModule } from '../default-site-sections/default-site-sections.module';
import { ProductGroupDetailComponent } from '../product/product-group-detail/product-group-detail.component';
import { ProductRangeDetailComponent } from '../product/product-range-detail/product-range-detail.component';
import { QuestionnaireCompleteComponent } from '../questionnaire/questionnaire-complete/questionnaire-complete.component';
import { QuestionnaireRespondComponent } from '../questionnaire/questionnaire-respond/questionnaire-respond.component';
import { MarketplaceComponent } from '../product/marketplace/marketplace.component';

const routes: Routes = [
    {
        path: '',
        component: DefaultLayoutComponent,
        children: [
            { path: 'product-groups/:slug', component: ProductGroupDetailComponent, pathMatch: 'full' },
            { path: 'product-ranges/:slug', component: ProductRangeDetailComponent, pathMatch: 'full' },
            { path: 'signout', canActivate: [AuthGuard], component: SignoutComponent, pathMatch: 'full' },
            { path: 'questionnaire/complete', component: QuestionnaireCompleteComponent, pathMatch: 'full' },
            { path: 'questionnaire/:id', component: QuestionnaireRespondComponent, pathMatch: 'full' },
            { path: 'help/:slug', component: FaqComponent, pathMatch: 'full' },
            { path: 'about-us/:slug', component: StaffComponent, pathMatch: 'full' },
            { path: 'login', component: LoginComponent, pathMatch: 'full', canActivate: [LoginGuard] },
            { path: 'register', component: RegisterComponent, pathMatch: 'full' },
            { path: 'register/:referralCode', component: RegisterComponent, pathMatch: 'full' },
            { path: 'trade-account', component: RegisterComponent, pathMatch: 'full', data: { accountType: 'trade' } },
            {
                path: 'trade-account/:regPromoCode',
                component: RegisterComponent,
                pathMatch: 'full',
                data: { accountType: 'trade' },
            },

            {
                path: 'blog-and-news/categories',
                component: CategoriesComponent,
                runGuardsAndResolvers: 'always',
                pathMatch: 'full',
            },
            {
                path: 'blog-and-news/:categorySlug',
                component: BlogCategoryComponent,
                runGuardsAndResolvers: 'always',
                pathMatch: 'full',
            },
            {
                path: 'blog-and-news/:categorySlug/:articleSlug',
                component: ArticleComponent,
                runGuardsAndResolvers: 'always',
                pathMatch: 'full',
            },
            {
                path: 'products/marketplace',
                component: MarketplaceComponent,
                runGuardsAndResolvers: 'always',
                pathMatch: 'full',
            },
        ],
    },
];

@NgModule({
    declarations: [DefaultLayoutComponent],
    imports: [
        CommonModule,
        [RouterModule.forChild(routes)],
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        DefaultSiteSectionsModule,
        AngularSvgIconModule,
        ChatModule,
        BlogModule,
        CookieConsentModule,
    ],
    exports: [[RouterModule]],
})
export class DefaultLayoutModule { }
